<template>
  <div>
    <!-- <header-title class='header-title' :text='text'></header-title> -->
    <div class="main">
      <el-row>
        <el-col :span=5 v-if="isSearch">
          <el-input v-model="inputKey" suffix-icon="el-icon-search" @change="search" @keyup.enter="search" placeholder="搜索"></el-input>
        </el-col>
        <el-col :span=5 :offset=14  :style="{'padding-top:5px':(isAdd&&isDel)?'5px':'0'}">
          <el-button class="btn" type="danger" :disabled="selectedRow.length==0" @click="del" size='mini' icon="el-icon-delete" v-if="isDel">删除</el-button>
          <el-button class="btn" type="primary" @click="add" size='mini' icon="el-icon-plus" v-if="isAdd">添加</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span=24>
          <my-table 
          @callEvent="callEvent"
          :pageSizesCount="pageSizesCount"
          activeTxt='激活' 
          inactiveTxt='停用' 
          :tableColName="tableColName" 
          :tableData="originData"
          ></my-table>
	      <!-- <my-table 
          @callEvent=callEvent
          :pageSizesCount=pageSizesCount
          activeTxt='激活' 
          inactiveTxt='停用' 
          :tableColName=tableColName 
          :tableData=tableData
          ></my-table> -->
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
// import headerTitle from './rectangle'
import myTable from './table'
// import pro from '../../utils/profession'
export default {
  name: 'tablePage',
  data() {
    return {
      inputKey: '',
      selectedRow: [],
      tableData: []
    }
  },
  props: {
    isSearch:{
      type:Boolean,
      default:()=>{
        return false
      }
    },
    isDel:{
      type:Boolean,
      default:()=>{
        return false
      }
    },
    isAdd:{
      type:Boolean,
      default:()=>{
        return false
      }
    },
    pageSizesCount:{
      type:Number,
      default:()=>{
        return -1  //-1表示不分页
      }
    },
    excludeField:{
      type:Array,
      default:()=>{
        return []
      }
    },
    text:{
      type:String,
      default:()=>{
        return ''
      }
    },
    tableColName: Array,
    originData: Array
  },
  components: {
    // headerTitle,
    myTable
  },
  watch: {
    originData: {
      handler(value) {
        this.tableData = value
      },
      deep: true
    }
  },
  mounted() {
    // this.getTableData()
  },
  methods: {
    callEvent(index,row,colData){
      this.$emit('callEvent',index,row,colData)
    },
    add() {
      this.$emit('add')
    },
    del() {
      if (!confirm('是否要删除？')) {
        return
      }
      this.$emit('del')
    }
    // search() {
    //   let excludeField = this.excludeField
    //   this.tableData = pro.search(
    //     this.originData,
    //     this.inputKey,
    //     excludeField,
    //     '激活',
    //     '停用'
    //   )
    // },
  }
}
</script>

<style lang='scss' scoped>
.main {
  // padding-top: 28px;
}
.btn {
  float: right;
}
.btn:first-child {
  margin-right: 10px;
}
.btn:nth-child(2) {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tablePage.vue